import { render, staticRenderFns } from "./confirmWidthdraw.vue?vue&type=template&id=064e63db&scoped=true"
import script from "./confirmWidthdraw.vue?vue&type=script&lang=js"
export * from "./confirmWidthdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e63db",
  null
  
)

export default component.exports